import React from 'react';

/**
 * L'en-tête d'une section, à l'intérieur d'un onglet ou en tête de page.
 *
 * Pastille à l'accent de la section, titre, sous-titre qui dit ce que ces
 * réglages changent, et une zone d'actions à droite.
 *
 * La norme : PARAMETRAGE-MODULES.md §3.
 */
const EnTeteSection = ({ icone: Icone, titre, sousTitre, accent = '#246990', accentSombre, actions }) => (
  <div className="flex flex-wrap items-center justify-between gap-3 pb-4 border-b border-gray-100">
    <div className="flex items-center gap-3">
      {Icone && (
        <div
          className="w-10 h-10 rounded-xl flex items-center justify-center shadow-sm flex-shrink-0"
          style={{ backgroundImage: `linear-gradient(to bottom right, ${accent}, ${accentSombre || accent})` }}
        >
          <Icone className="text-white" size={18} />
        </div>
      )}
      <div>
        <h2 className="text-[15px] font-bold text-gray-900">{titre}</h2>
        {sousTitre && <p className="text-xs text-gray-500 mt-0.5">{sousTitre}</p>}
      </div>
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);

export default EnTeteSection;
